import { render, staticRenderFns } from "./applyRoomDiscountManageList.vue?vue&type=template&id=661bdc63&scoped=true"
import script from "./applyRoomDiscountManageList.vue?vue&type=script&lang=js"
export * from "./applyRoomDiscountManageList.vue?vue&type=script&lang=js"
import style0 from "./applyRoomDiscountManageList.vue?vue&type=style&index=0&id=661bdc63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661bdc63",
  null
  
)

export default component.exports